import * as React from 'react';
import { observer } from 'mobx-react';
import { authService } from './index';
import { AppTheme, Layout, Login } from './Components';

import './App.css';

@observer
export class App extends React.Component {

    componentWillUnmount () {
        authService.stopTokenAutoRefresh();
    }

    render () {
        const { currentUser } = authService;

        if (!currentUser) {
            return <Login/>;
        }

        return (
            <AppTheme>
                <Layout/>
            </AppTheme>
        );
    }
}